import React from 'react'

const Inbox = () => {
  return (
    <div className="content">
      <h2>Inbox</h2>
      <ul>
        <li>Message Info</li>
      </ul>
    </div>
  )
}

export default Inbox
